// SNKRR BAR — welcome popup + exit-intent popup
// Captures email (required) and optional US phone for SMS code delivery
// Submits via real form POST (target=_top) so Shopify Bot Protection works.
// Uses return_to param + snkrr_signup query param to display a toast after redirect.
(function(){
  'use strict';

  // =============================================================
  // POST-REDIRECT TOAST: runs on every page load to detect successful
  // popup submissions (signaled via ?snkrr_signup=email|sms) and show
  // a confirmation toast, then clean the URL.
  // =============================================================
  (function showPostSignupToast() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch(e) { return; }
    var signup = params.get('snkrr_signup');
    if (!signup) return;

    function buildToast() {
      var toast = document.createElement('div');
      toast.className = 'snkrr-toast snkrr-toast--signup';
      var heading = signup === 'sms'
        ? 'Check your phone in 30 seconds.'
        : 'Check your inbox in 2 minutes.';
      var body = signup === 'sms'
        ? 'Your one-time 10% off code is on its way via text. We also sent a backup to your inbox.'
        : 'Your one-time 10% off code is on its way to your inbox. $39.99 minimum, single use.';
      toast.innerHTML =
        '<div class="snkrr-toast__icon" aria-hidden="true">&#10003;</div>' +
        '<div class="snkrr-toast__body">' +
          '<p class="snkrr-toast__h">' + heading + '</p>' +
          '<p class="snkrr-toast__sub">' + body + '</p>' +
        '</div>' +
        '<button class="snkrr-toast__close" type="button" aria-label="Dismiss">&times;</button>';
      document.body.appendChild(toast);

      requestAnimationFrame(function(){ toast.classList.add('snkrr-toast--in'); });

      var dismiss = function() {
        toast.classList.remove('snkrr-toast--in');
        setTimeout(function(){ try { toast.remove(); } catch(e){} }, 300);
      };
      toast.querySelector('.snkrr-toast__close').addEventListener('click', dismiss);
      setTimeout(dismiss, 8000);

      try {
        params.delete('snkrr_signup');
        params.delete('customer_posted');
        var newSearch = params.toString();
        var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
        history.replaceState({}, '', newUrl);
      } catch(e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', buildToast);
    } else {
      buildToast();
    }
  })();

  var STORAGE_WELCOME = 'snkrr-welcome-seen';
  var STORAGE_EXIT = 'snkrr-exit-seen';
  var WELCOME_DELAY_MS = 15000;
  var WELCOME_SCROLL_PCT = 60;
  var TODAY = new Date().toISOString().slice(0,10);

  function seen(key){ try { return localStorage.getItem(key) === TODAY; } catch(e){ return false; } }
  function mark(key){ try { localStorage.setItem(key, TODAY); } catch(e){} }

  function isCustomerEngaged(){
    return !!document.querySelector(
      'cart-drawer.active, cart-drawer.animate, .cart-drawer.active, .drawer.active, ' +
      'cart-notification.active, dialog[open], details[open] menu-drawer, ' +
      '.menu-drawer.menu-opening, .header__icon--menu[aria-expanded="true"]'
    );
  }

  function normalizePhone(raw){
    if (!raw) return '';
    var digits = String(raw).replace(/\D/g, '');
    if (!digits) return '';
    // Drop leading 1 if 11 digits (treat as US country code)
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.substring(1);
    if (digits.length !== 10) return '';
    return '+1' + digits;
  }

  function buildModal(opts){
    if (isCustomerEngaged()) return;
    var wrap = document.createElement('div');
    wrap.className = 'snkrr-modal-overlay';
    wrap.innerHTML =
      '<div class="snkrr-modal" role="dialog" aria-modal="true">' +
        '<button class="snkrr-modal__close" type="button" aria-label="Close">&times;</button>' +
        '<p class="snkrr-modal__eyebrow">'+opts.eyebrow+'</p>' +
        '<h3 class="snkrr-modal__h">'+opts.h+'</h3>' +
        '<p class="snkrr-modal__sub">'+opts.sub+'</p>' +
        '<div class="snkrr-modal__form">' +
          '<input type="email" class="snkrr-modal__email" placeholder="Your email" required autocomplete="email" autofocus>' +
          '<div class="snkrr-modal__phone-wrap">' +
            '<span class="snkrr-modal__phone-prefix" aria-hidden="true">+1</span>' +
            '<input type="tel" class="snkrr-modal__phone" placeholder="Phone (optional, faster code delivery)" autocomplete="tel-national" maxlength="14">' +
          '</div>' +
          '<label class="snkrr-modal__consent" hidden>' +
            '<input type="checkbox" class="snkrr-modal__consent-box">' +
            '<span class="snkrr-modal__consent-text">' +
              'Text my 10% code now (and future drop alerts). By checking, I agree to receive recurring automated marketing texts from SNKRR BAR at the number above. Consent not required for purchase. Msg & data rates may apply. Msg frequency varies. Reply STOP to opt out, HELP for help. ' +
              '<a href="/pages/terms-of-service" target="_blank">Terms</a> & <a href="/policies/privacy-policy" target="_blank">Privacy</a>.' +
            '</span>' +
          '</label>' +
          '<button type="button" class="snkrr-modal__btn snkrr-modal__submit">'+opts.btn+'</button>' +
        '</div>' +
        '<div class="snkrr-modal__reveal" style="display:none;">' +
          '<div class="snkrr-modal__success">You are in.</div>' +
          '<p class="snkrr-modal__reveal-h" data-reveal-h>Check your inbox for your code.</p>' +
          '<p class="snkrr-modal__fineprint" data-reveal-p>We just sent your one-time 10% off code. Minimum $39.99. Single use, only yours.</p>' +
        '</div>' +
        '<p class="snkrr-modal__fineprint snkrr-modal__fineprint--default">No spam. Unsubscribe anytime.</p>' +
      '</div>';
    document.body.appendChild(wrap);

    var closeBtn = wrap.querySelector('.snkrr-modal__close');
    var overlay = wrap;
    var emailInput = wrap.querySelector('.snkrr-modal__email');
    var phoneInput = wrap.querySelector('.snkrr-modal__phone');
    var consentLabel = wrap.querySelector('.snkrr-modal__consent');
    var consentBox = wrap.querySelector('.snkrr-modal__consent-box');
    var submitBtn = wrap.querySelector('.snkrr-modal__submit');
    var formArea = wrap.querySelector('.snkrr-modal__form');
    var reveal = wrap.querySelector('.snkrr-modal__reveal');
    var revealH = wrap.querySelector('[data-reveal-h]');
    var revealP = wrap.querySelector('[data-reveal-p]');
    var fineprint = wrap.querySelector('.snkrr-modal__fineprint--default');

    function close(){
      wrap.classList.remove('is-open');
      setTimeout(function(){ wrap.remove(); }, 300);
    }
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
    var escHandler = function(e){ if (e.key === 'Escape') { close(); document.removeEventListener('keydown', escHandler); } };
    document.addEventListener('keydown', escHandler);

    // Show TCPA consent only when user starts typing a phone
    phoneInput.addEventListener('input', function(){
      var hasPhone = phoneInput.value.replace(/\D/g, '').length >= 3;
      if (hasPhone) {
        consentLabel.hidden = false;
      } else {
        consentLabel.hidden = true;
        consentBox.checked = false;
      }
    });

    function reveal_code(email, normalizedPhone, smsConsent){
      // Submit through the ORIGINAL Liquid-rendered customer form in #snkrr-csrf-source.
      // Shopify's Bot Protection JS hooked that form at page load — it must be the same
      // DOM element (not a clone) so the captcha token gets attached before submit.
      // requestSubmit() fires a submit event (captcha intercepts), then form posts
      // with target=_top, Shopify processes, redirects to return_to with success param.
      try {
        var sourceForm = document.querySelector('#snkrr-csrf-source form');
        if (!sourceForm) throw new Error('No source form');

        function setField(name, value) {
          var el = sourceForm.querySelector('input[name="' + name + '"]');
          if (!el) {
            el = document.createElement('input');
            el.type = 'hidden';
            el.name = name;
            sourceForm.appendChild(el);
          }
          el.value = value;
        }

        setField('contact[email]', email);
        setField('contact[accepts_marketing]', 'yes');
        var tags = ['welcome-popup'];
        var signupType = 'email';
        if (normalizedPhone && smsConsent) {
          setField('contact[phone]', normalizedPhone);
          tags.push('sms-optin-popup');
          signupType = 'sms';
        }
        setField('contact[tags]', tags.join(','));
        setField('return_to', window.location.pathname + '?snkrr_signup=' + signupType);

        // Captcha intercepts submit events. requestSubmit() fires a real submit event.
        sourceForm.target = '_top';

        // Need a submit button for requestSubmit() to work in some browsers
        if (!sourceForm.querySelector('button[type="submit"], input[type="submit"]')) {
          var hiddenBtn = document.createElement('button');
          hiddenBtn.type = 'submit';
          hiddenBtn.style.display = 'none';
          sourceForm.appendChild(hiddenBtn);
        }

        // Show transient "Sending..." state
        formArea.style.display = 'none';
        if (fineprint) fineprint.style.display = 'none';
        revealH.textContent = 'Sending...';
        revealP.textContent = "Hold on, we're setting up your code.";
        reveal.style.display = 'block';

        if (typeof sourceForm.requestSubmit === 'function') {
          sourceForm.requestSubmit();
        } else {
          sourceForm.submit();
        }
      } catch(err){
        formArea.style.display = 'none';
        if (fineprint) fineprint.style.display = 'none';
        revealH.textContent = 'Something went wrong.';
        revealP.textContent = 'Please refresh and try again, or email info@snkrrbar.com.';
        reveal.style.display = 'block';
      }
    }

    submitBtn.addEventListener('click', function(){
      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') < 1) {
        emailInput.focus();
        emailInput.style.borderColor = '#c0392b';
        return;
      }

      // Phone is optional, but if filled it must be valid + consent must be checked
      var phoneRaw = (phoneInput.value || '').trim();
      var normalizedPhone = '';
      var smsConsent = false;
      if (phoneRaw) {
        normalizedPhone = normalizePhone(phoneRaw);
        if (!normalizedPhone) {
          phoneInput.focus();
          phoneInput.style.borderColor = '#c0392b';
          return;
        }
        smsConsent = consentBox.checked;
        if (!smsConsent) {
          // They provided a phone but didn't consent — highlight the checkbox
          consentLabel.classList.add('snkrr-modal__consent--needed');
          consentBox.focus();
          return;
        }
      }

      reveal_code(email, normalizedPhone, smsConsent);
    });

    emailInput.addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); phoneInput.focus(); }
    });
    phoneInput.addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); submitBtn.click(); }
    });

    requestAnimationFrame(function(){
      wrap.classList.add('is-open');
      setTimeout(function(){ try { emailInput.focus({ preventScroll: true }); } catch(e){ emailInput.focus(); } }, 350);
    });
  }

  function showWelcome(){
    if (seen(STORAGE_WELCOME)) return;
    if (isCustomerEngaged()) return;
    mark(STORAGE_WELCOME);
    buildModal({
      eyebrow: 'Welcome to SNKRR BAR',
      h: 'Get 10% off your first kit.',
      sub: 'Plus early access to drops, restocks, and exclusive solutions.',
      btn: 'Get my 10% off'
    });
  }

  function showExit(){
    if (seen(STORAGE_EXIT)) return;
    if (isCustomerEngaged()) return;
    if (document.querySelector('.snkrr-modal-overlay.is-open')) return;
    mark(STORAGE_EXIT);
    buildModal({
      eyebrow: 'Wait. Before you go.',
      h: 'Take 10% off your first kit.',
      sub: 'Drop your email and we will send a code that works on every Solution.',
      btn: 'Send me the code'
    });
  }

  setTimeout(showWelcome, WELCOME_DELAY_MS);
  window.addEventListener('scroll', function() {
    var scrolled = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
    if (scrolled > WELCOME_SCROLL_PCT) showWelcome();
  }, { passive: true });

  if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
    document.addEventListener('mouseleave', function(e){
      if (e.clientY < 5) showExit();
    });
  }
})();
